import styled from 'styled-components';
import ThinDivider from '../ThinDivider';

export default styled(ThinDivider).attrs({
  layout: 'horizontal',
  size: 'full',
})<{
  $hasExtendedOffset?: boolean;
}>`
  margin-top: 16px;
  margin-bottom: ${({ $hasExtendedOffset }) =>
    $hasExtendedOffset ? '24px' : '16px'};
`;
